import React, { useState, useEffect } from "react";
import useStyles from "../user/styles";
import useStylesProfit from "../partner/style";
import { useLocation, useHistory } from "react-router-dom";
import config from "../../config";

// components
import InputComponent from "../partner/components/inputComponent";
import InputSelect from "../partner/components/inputSelect";
import PageTitle from "../../components/PageTitle/PageTitle";
import { CircularProgress } from "@material-ui/core";
import InputDisableSimpleText from "../user/components/inputDisableSimpleText";
import SwitchToUseGym from "../user/components/switch";
import { TextField } from "@material-ui/core";
import { Edit, Delete } from "@material-ui/icons";
import Modal from "../modals/Modal";
import InputDecimalInventory from './components/inputDecimal';

export default function ProductInfo() {
    const expressions = {
        usuario: /^[a-zA-Z0-9_-]{4,16}$/, // Letras, numeros, guion y guion_bajo
        nombre: /^[a-zA-ZÀ-ÿ\s]{1,40}$/, // Letras y espacios, pueden llevar acentos.
        password: /^.{4,12}$/, // 4 a 12 digitos.
        email: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
        numbers: /^[0-9]*$/, // 7 a 14 numeros.
        descShort: /^[a-zA-ZÀ-ÿ\s#, ]{1,200}$/, // Letras y espacios, pueden llevar acentos.
        texto: /^[a-zA-ZÀ-ÿ\s0-9 ]{4,500}$/, // Letras
    }

    const classes = useStyles();
    const location = useLocation();
    let history = useHistory();
    const classesProfit = useStylesProfit();

    const [baseUrl, setBaseUrl] = useState(config.config[0].baseUrl);
    const [name, setName] = useState({ text: '', valid: null });
    const [barcode, setBarcode] = useState({ text: '', valid: null });
    const [category, setCategory] = useState({ text: '', valid: null });
    const [cost, setCost] = useState({ text: 0.00, valid: null });
    const [profitCost, setProfitCost] = useState({ text: '', isProfitByPercent: false, valid: null });
    const [description, setDescription] = useState({ text: '', valid: null });
    const [isOwnProduct, setIsOwnProduct] = useState(false);
    const [minStock, setMinStock] = useState({ text: null, valid: null });
    const [note, setNote] = useState({ text: '', valid: null });
    const [salePrice, setSalePrice] = useState({ text: 0.00, valid: null });
    const [saleUnit, setSaleUnit] = useState({ text: '', valid: null });
    const [supplier, setSupplier] = useState({ text: '', valid: null });
    const [productStatus, setProductStatus] = useState({ text: '', valid: null });
    const [stock, setStock] = useState({ text: '', valid: null });
    const [creationDate, setCreationDate] = useState('');
    const [lastUpdateDate, setLastUpdateDate] = useState('');

    const [productInfo, setProductInfo] = useState([]);
    const [allStatus, setAllStatus] = useState([]);
    const [allCategories, setAllCategories] = useState([]);
    const [allSaleUnit, setAllSaleUnit] = useState([]);
    const [allSuppliers, setAllSuppliers] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isLoadingToSaveProduct, setIsLoadingToSaveProduct] = useState(false);
    const [disableInpunts, setDisableInpunts] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [isPercentSelected, setIsPercentSelected] = useState(false);

    const closeModalLogin = e => {
        setShowModal(false);
    }

    const fetchProductInfo = async () => {
        var id = '';

        try {
            if (location.state.id == null) {
                id = location.state.id;
            } else {
                id = localStorage.getItem('productInfo');
            }
        } catch (e) {
            id = localStorage.getItem('productInfo');
        }

        fetch(baseUrl + "productById/" + id,
            {
                headers: {
                    'Accept': 'application/json', 'Content-Type': 'application/json',
                    'Authorization': localStorage.getItem("token")
                },
            })
            .then(response => response.json())
            .then(data => {
                if (data != null) {
                    setProductInfo(data);
                    setName({ text: data.name, valid: 'true' });
                    setBarcode({ text: data.barcode, valid: 'true' });
                    setCategory({ text: data.category, valid: 'true' });
                    setCost({ text: data.cost, valid: 'true' });
                    setProfitCost({ text: data.productProfit, isProfitByPercent: data.isProfitByPercent == 0 ? false : true, valid: 'true' });
                    setDescription({ text: data.description, valid: 'true' });
                    setIsOwnProduct(data.isOwnProduct == 1 ? true : false);
                    setMinStock({ text: data.minStock, valid: 'true' });
                    setNote({ text: data.note, valid: 'true' });
                    setSalePrice({ text: data.salePrice, valid: 'true' });
                    setSaleUnit({ text: data.saleUnit, valid: 'true' });
                    setProductStatus({ text: data.productStatus, valid: 'true' });
                    setStock({ text: data.stock, valid: 'true' });
                    setSupplier({ text: data.supplier, valid: 'true' });
                    setCreationDate(data.creationDate);
                    setLastUpdateDate(data.lastUpdateDate);

                    setIsLoading(false);
                } else {
                    setShowModal(true);
                }

                setIsLoading(false);
            })
            .catch(error => null);
    }

    const fetchGenericStatus = async () => {
        if (!showModal) {
            fetch(baseUrl + "genericStatus",
                {
                    headers: {
                        'Accept': 'application/json', 'Content-Type': 'application/json',
                        'Authorization': localStorage.getItem("token")
                    },
                }).then(response => response.json())
                .then(data => {
                    if (data != null) {
                        setAllStatus(data);
                    } else {
                        setShowModal(true);
                    }
                }).catch(error => null);
        }
    }

    const fetchCategories = async () => {
        if (!showModal) {
            fetch(baseUrl + "categoryProduct",
                {
                    headers: {
                        'Accept': 'application/json', 'Content-Type': 'application/json',
                        'Authorization': localStorage.getItem("token")
                    },
                }).then(response => response.json())
                .then(data => {
                    if (data != null) {
                        setAllCategories(data);
                    } else {
                        setShowModal(true);
                    }
                }).catch(error => null);
        }
    }

    const fetchSaleUnit = async () => {
        if (!showModal) {
            fetch(baseUrl + "saleUnit",
                {
                    headers: {
                        'Accept': 'application/json', 'Content-Type': 'application/json',
                        'Authorization': localStorage.getItem("token")
                    },
                }).then(response => response.json())
                .then(data => {
                    if (data != null) {
                        setAllSaleUnit(data);
                    } else {
                        setShowModal(true);
                    }
                }).catch(error => null);
        }
    }

    const fetchSupplier = async () => {
        if (!showModal) {
            fetch(baseUrl + "supplier",
                {
                    headers: {
                        'Accept': 'application/json', 'Content-Type': 'application/json',
                        'Authorization': localStorage.getItem("token")
                    },
                }).then(response => response.json())
                .then(data => {
                    if (data != null) {
                        setAllSuppliers(data);
                    } else {
                        setShowModal(true);
                    }
                }).catch(error => null);
        }
    }

    useEffect(() => {
        fetchProductInfo();
        fetchGenericStatus();
        fetchCategories();
        fetchSaleUnit();
        fetchSupplier();
    }, [location]);

    const onSubmit = async e => {
        e.preventDefault();
        setIsLoadingToSaveProduct(true);

        const updateProduct = {
            id: productInfo.id, barcode: barcode.text, category: category.text,
            cost: cost.text, description: description.text, isOwnProduct: isOwnProduct ? 1 : 0,
            isProfitByPercent: profitCost.isProfitByPercent ? 1 : 0, minStock: minStock.text, name: name.text,
            note: note.text, productProfit: profitCost.text, productStatus: productStatus.text,
            salePrice: salePrice.text, saleUnit: saleUnit.text, stock: stock.text, supplier: supplier.text
        };

        const response = await fetch(baseUrl + "updateProduct/", {
            method: 'PUT',
            headers: {
                'Accept': 'application/json', 'Content-Type': 'application/json',
                'Authorization': localStorage.getItem("token")
            },
            body: JSON.stringify(updateProduct)
        });

        const json = await response.json();
        if (json.message == "Ok") {
            window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
        } else {
            if (json.message == "Access is denied") {
                setShowModal(true);
            }
        }

        setIsLoadingToSaveProduct(false);
        setDisableInpunts(true);
        fetchProductInfo();
    }

    const onDelete = async e => {
        e.preventDefault();
        setIsLoadingToSaveProduct(true);

        const response = await fetch(baseUrl + "deleteProduct/" + productInfo.id, {
            method: 'DELETE',
            headers: {
                'Accept': 'application/json', 'Content-Type': 'application/json',
                'Authorization': localStorage.getItem("token")
            },
        });

        const json = await response.json();
        if (json.message == "Ok") {
            localStorage.removeItem("productInfo");
            history.goBack();
        } else {
            if (json.message == "Access is denied") {
                setShowModal(true);
            }
        }
        setDisableInpunts(!disableInpunts);
        setIsLoadingToSaveProduct(false);
    }

    const calculatePrice = () => {
        if (cost.text != 0.00 && profitCost.text != 0.00) {
            if (profitCost.isProfitByPercent) {
                setSalePrice({
                    text: (parseFloat(cost.text) + (parseFloat(cost.text) * (parseFloat(profitCost.text)).toFixed(0) / 100)).toFixed(2),
                    valid: "true"
                });
            } else {
                setSalePrice({
                    text: (parseFloat(cost.text) + parseFloat(profitCost.text)).toFixed(2),
                    valid: "true"
                });
            }
        } else {
            setSalePrice({
                text: cost.text,
                valid: "false"
            });
        }
    }

    const onChange = (e) => {
        let start = e.target.selectionStart;
        let val = e.target.value;
        val = val.replace(/([^0-9.]+)/, "");
        val = val.replace(/^(0|\.)/, "");
        const match = /(\d{0,7})[^.]*((?:\.\d{0,2})?)/g.exec(val);
        const value = match[1] + match[2];
        e.target.value = value;

        if (val.length > 0) {
            e.target.value = Number(value).toFixed(2);
            e.target.setSelectionRange(start, start);
            setProfitCost({ ...profitCost, text: Number(value).toFixed(2) });
        }
    }
    const validateField = () => {
        if (profitCost.text != '') {
            setProfitCost({ ...profitCost, valid: 'true' });
            calculatePrice();
        } else {
            setProfitCost({ ...profitCost, valid: 'false' });
            calculatePrice();
        }
    }

    const buttonSelected = (index) => (event) => {
        if (index == 1) {
            setIsPercentSelected(false);
            setProfitCost({ ...profitCost, isProfitByPercent: false });
            setSalePrice({
                text: (parseFloat(cost.text) + parseFloat(profitCost.text)).toFixed(2),
                valid: "true"
            });
        } else {
            setIsPercentSelected(true);
            setProfitCost({ ...profitCost, isProfitByPercent: true });
            setSalePrice({
                text: (parseFloat(cost.text) + (parseFloat(cost.text) * (parseFloat(profitCost.text)).toFixed(0) / 100)).toFixed(2),
                valid: "true"
            });
        }
    };

    return (
        <div>
            {showModal ? (
                <Modal
                    isOpen={showModal}
                    closeModal={closeModalLogin}
                />
            ) : (
                <></>
            )}
            <div className={classes.titleRow}>
                <PageTitle title="Información del producto" />

                {isLoading ? (
                    <></>
                ) : (
                    <>
                        <div className={classes.marginAuto} />
                        <div className={classes.divActionButton} >
                            <Edit classes={{ root: classes.searchIcon }}
                                onClick={() => {
                                    setDisableInpunts(!disableInpunts);
                                }}
                            />
                        </div>
                        <div className={classes.divActionButtonDisable} >
                            <Delete
                                classes={{ root: !disableInpunts ? classes.activeButtonDisable : classes.searchIcon }}
                                onClick={!disableInpunts ? null : onDelete}
                            />
                        </div>
                    </>
                )}
            </div>

            <div className={classes.divCard} >
                {isLoading ? (
                    <CircularProgress size={26} className={classes.loginPage} />
                ) : (
                    <div className={classes.divThreeColumns} >
                        <InputComponent
                            text={name}
                            setPartnerCode={setName}
                            type="text"
                            label="Nombre"
                            name="name"
                            regularExpression={expressions.texto}
                            placeholder="Nombre"
                            isEnable={disableInpunts}
                        />

                        <InputComponent
                            text={barcode}
                            setPartnerCode={setBarcode}
                            type="text"
                            label="Código de barras"
                            name="barcode"
                            regularExpression={expressions.texto}
                            placeholder="código"
                            isEnable={disableInpunts}
                        />

                        <InputComponent
                            text={description}
                            setPartnerCode={setDescription}
                            type="text"
                            label="Descripción"
                            name="description"
                            regularExpression={expressions.descShort}
                            placeholder="Descripción corta"
                            isEnable={disableInpunts}
                        />

                        <InputSelect
                            text={category}
                            setValue={setCategory}
                            label={"Categoría"}
                            options={allCategories}
                            isEnable={disableInpunts}
                        />

                        <InputSelect
                            text={saleUnit}
                            setValue={setSaleUnit}
                            label={"Unidad de venta"}
                            options={allSaleUnit}
                            isEnable={disableInpunts}
                        />

                        <SwitchToUseGym
                            value={isOwnProduct}
                            label={"Producto propio"}
                            setValue={setIsOwnProduct}
                            isEnable={disableInpunts}
                        />

                        <InputComponent
                            text={minStock}
                            setPartnerCode={setMinStock}
                            type="number"
                            label="Stock mínimo"
                            name="minStock"
                            regularExpression={expressions.numbers}
                            placeholder="1"
                            isEnable={disableInpunts}
                        />

                        <InputComponent
                            text={stock}
                            setPartnerCode={setStock}
                            type="number"
                            label="Stock"
                            name="stock"
                            regularExpression={expressions.numbers}
                            placeholder="0"
                            isEnable={disableInpunts}
                        />

                        <InputDecimalInventory
                            text={cost}
                            setPartnerCode={setCost}
                            type="text"
                            label="Costo"
                            name="cost"
                            placeholder="100.00"
                            calculate={calculatePrice}
                            isEnable={disableInpunts}
                        />

                        <div>
                            <div className={classesProfit.divLabel}>
                                <p className={classesProfit.label} >Ganancia del producto</p>
                            </div>
                            <div className={classesProfit.rowButtons}>
                                <div style={{ display: "flex" }}>
                                    <button
                                        disabled={disableInpunts}
                                        className={!isPercentSelected ? classesProfit.selectedButtonProfitLeft : classesProfit.enableButtonProfitLeft}
                                        onClick={buttonSelected(1)}
                                    >Efectivo</button>

                                    <button
                                        disabled={disableInpunts}
                                        className={isPercentSelected ? classesProfit.selectedButtonProfitRight : classesProfit.enableButtonProfitRight}
                                        onClick={buttonSelected(2)}
                                    >Porcentaje</button>
                                </div>

                                <div style={{ display: "flex", justify: "center", alignItems: "center" }}>
                                    {!isPercentSelected ? (
                                        <p style={{ fontSize: "18px" }}>$</p>
                                    ) : (
                                        <></>
                                    )}

                                    <TextField
                                        InputProps={{
                                            classes: {
                                                focused: classesProfit.textBorder,
                                                input: classesProfit.input,
                                            },
                                        }}
                                        disabled={disableInpunts}
                                        value={profitCost.text}
                                        onChange={onChange}
                                        placeholder="100.00"
                                        type='text'
                                        name='profitProduct'
                                        onKeyUp={validateField}
                                        onBlur={validateField}
                                        style={{ width: '85%' }}
                                        inputStyle={{ width: '85%' }}
                                    />

                                    {isPercentSelected ? (
                                        <p style={{ fontSize: "18px" }}>%</p>
                                    ) : (
                                        <></>
                                    )}
                                </div>
                            </div>
                        </div>

                        <InputDisableSimpleText
                            value={salePrice.text}
                            type="text"
                            label="Precio de venta"
                            name="salePrice"
                            placeholder="100.00"
                            isPrice={true}
                        />

                        <InputComponent
                            text={note}
                            setPartnerCode={setNote}
                            type="text"
                            label="Nota"
                            name="note"
                            regularExpression={expressions.texto}
                            placeholder="Nota corta"
                            isEnable={disableInpunts}
                        />

                        <InputSelect
                            text={productStatus}
                            setValue={setProductStatus}
                            label={"Estado"}
                            options={allStatus}
                            isEnable={disableInpunts}
                        />

                        <InputSelect
                            text={supplier}
                            setValue={setSupplier}
                            label={"Proveedor"}
                            options={allSuppliers}
                            isEnable={disableInpunts}
                        />

                        <InputDisableSimpleText
                            value={creationDate}
                            type="text"
                            label="Fecha de alta"
                            name="creationDate"
                            placeholder="Fecha"
                            isPrice={false}
                        />

                        <InputDisableSimpleText
                            value={lastUpdateDate}
                            type="text"
                            label="Última modificación"
                            name="lastUpdateDate"
                            placeholder="Fecha"
                            isPrice={false}
                        />
                    </div>
                )}

                {disableInpunts ? (
                    <br />
                ) : (
                    <div className={classes.divButton}>
                        {isLoadingToSaveProduct ? (
                            <div className={classes.loginLoader} >
                                <CircularProgress size={26} />
                            </div>
                        ) : (
                            <button
                                className={classes.enableButton}
                                onClick={onSubmit}
                            >Guardar</button>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
}
